import React, { Fragment } from 'react';
// import { useFormContext } from 'react-hook-form'
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
import Input from 'components/Input';
import useSWR from 'swr';
import { filterValues, formatValues } from 'Helper';
import MultiSelect from 'components/MultiSelect';
import Map from 'pages/Promo/components/PromoCardDetails/components/Campaigns/Map';
import { Box } from '@mui/material';

export default function FormTwo() {
  const { data: interests } = useSWR('collections/interests')
  const { data: gender } = useSWR('collections/gender')
  const { data: professions } = useSWR('collections/professions')

  // const {getValues} = useFormContext()

  const fields = [
    [
      {
        name: 'professions',
        label: 'Professions',
        multi: true,
        options: professions?.data ? filterValues({ options: professions?.data, param: { label: 'name', value: 'id' } }) : []
      },
      {
        name: 'interests',
        label: 'Interests',
        multi: true,
        options: interests?.data ? filterValues({ options: interests?.data, param: { label: 'name', value: 'id' } }) : []
      },
    ],
    [
      {
        name: 'education',
        label: 'Education',
        options: [
          {
            value: 'JHS',
            label: 'Junior High School'
          },
          {
            value: 'SHS',
            label: 'Senior High School'
          },
          {
            value: 'votech',
            label: 'Vocation and Technical'
          },
          {
            value: 'university',
            label: 'University'
          },
        ]
        // options: education ? filterValues({options: education, param: {label: 'name', value: 'id'}}) : []
      },
      {
        name: 'religion',
        label: 'Religion',
        options: [
          {
            value: 'christian',
            label: 'Christian'
          },
          {
            value: 'muslim',
            label: 'Muslim'
          },
          {
            value: 'traditional',
            label: 'Traditional'
          },
          {
            value: 'other',
            label: 'Other'
          },
        ]
        // options: religion ? filterValues({options: religion, param: {label: 'name', value: 'id'}}) : []
      },
    ],
    [
      {
        name: 'gender',
        label: 'Gender',
        options: gender?.data ? formatValues(gender.data) : []
        // options: []
      },
      {
        name: 'status',
        label: 'Marital Status',
        options: [
          {
            value: 'married',
            label: 'Married'
          },
          {
            value: 'single',
            label: 'Single'
          },
          {
            value: 'widowed',
            label: 'Widowed'
          },
          {
            value: 'divorced',
            label: 'Divorced'
          },
          {
            value: 'co-habitation',
            label: 'Co-habitation'
          },
        ]
      },
    ],
    [
      {
        name: 'min_age',
        label: 'Minimum Age',
        placeholder: 'Eg. 18'
      },
      {
        name: 'max_age',
        label: 'Max Age',
        placeholder: 'Eg. 35'
      },
    ],
    {
      name: 'location',
      label: 'Location',
      placeholder: 'Enter location',
      require: true
    },
    {
      name: 'radius',
      label: 'Promo catchment radius',
      placeholder: 'Promotion target radius (Eg. 100)'
    }
  ]


  return (
    <>
      <div className="grid grid-cols-2 bg-dark gap-5 mb-8">
        {
          fields.map((field, index) => {
            return (
              <Fragment key={`${index}_`}>
                {
                  field.length ? (
                    <>
                      {
                        field.map(({ label, name, ...misc }) => {
                          return (
                            <Box key={name} sx={{ width: '100%', display: 'block',  flexDirection: { xs: 'column', lg: 'row' } }}>
                              {
                                !misc.multi ? (
                                  <Input
                                    name={name}
                                    label={label}
                                    options={misc?.options}
                                    placeholder={misc?.placeholder}
                                    variant="filled"
                                    key={name}
                                  />
                                ) : (
                                  <MultiSelect
                                    name={name}
                                    label={label}
                                    options={misc?.options ?? []}
                                    variant="filled"
                                    key={`${name}-${index}`}
                                  />
                                )
                              }
                            </Box>
                          )
                        })
                      }
                    </>
                  ) : (
                    // <div className="col-span-2">
                      <Input
                        name={field.name}
                        label={field.label}
                        options={field?.options}
                        placeholder={field?.placeholder}
                        variant="filled"
                      />
                    // </div>
                  )
                }
              </Fragment>
            )
          })
        }
      </div>

      <div className="col-span-1 h-[400px] mb-5 w-100% bg-slate-300">
        <Map />
      </div>
    </>
  )
}
